/**
 * Module Contrats — primitives UI partagées.
 *
 * Même trame que le module Santé : fond sombre, panneaux translucides,
 * champs adaptés au dark. Accent ambre (énergie).
 */
export const CONTRACTS_ACCENT = '#ffb547'
export const PANEL_BG = 'rgba(255,255,255,0.04)'
export const PAGE_BG = '#00001d'

export const cardSx = {
  bgcolor: PANEL_BG,
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: 3,
  p: 2.5,
}

export const darkFieldSx = {
  '& .MuiInputBase-input': { color: '#fff' },
  '& .MuiInputBase-input::placeholder': {
    color: 'rgba(255,255,255,0.4)',
    opacity: 1,
  },
  '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.6)' },
  '& .MuiInputLabel-root.Mui-focused': { color: CONTRACTS_ACCENT },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(255,255,255,0.25)',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(255,255,255,0.45)',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: CONTRACTS_ACCENT,
  },
  '& .MuiSvgIcon-root': { color: 'rgba(255,255,255,0.6)' },
  '& .MuiFormHelperText-root': { color: 'rgba(255,255,255,0.45)' },
}

// Libellés & couleurs par type de contrat (alignés sur le backend
// `Contracts/models.py::CONTRACT_TYPE_CHOICES`).
export const CONTRACT_TYPES = [
  { value: 'electricity', label: 'Électricité', color: '#ffb547' },
  { value: 'gas', label: 'Gaz', color: '#5aa7ff' },
  { value: 'water', label: 'Eau', color: '#3ddcd0' },
  { value: 'heating', label: 'Chauffage / fioul', color: '#ff7847' },
  { value: 'internet', label: 'Internet / box', color: '#b98cff' },
  { value: 'mobile', label: 'Téléphonie mobile', color: '#8cb5ff' },
  { value: 'insurance', label: 'Assurance', color: '#8affa1' },
  { value: 'streaming', label: 'Abonnement média', color: '#ff8cd2' },
  { value: 'other', label: 'Autre', color: '#c2c9e0' },
]

export const contractTypeMeta = (value) =>
  CONTRACT_TYPES.find((t) => t.value === value) || CONTRACT_TYPES[CONTRACT_TYPES.length - 1]

export const PAYMENT_FREQUENCIES = [
  { value: 'monthly', label: 'Mensuel' },
  { value: 'bimonthly', label: 'Bimestriel' },
  { value: 'quarterly', label: 'Trimestriel' },
  { value: 'semiannual', label: 'Semestriel' },
  { value: 'annual', label: 'Annuel' },
]

export const DOCUMENT_TYPES = [
  { value: 'invoice', label: 'Facture' },
  { value: 'contract', label: 'Contrat' },
  { value: 'terms', label: 'Conditions générales' },
  { value: 'amendment', label: 'Avenant' },
  { value: 'other', label: 'Autre' },
]

export const documentTypeLabel = (value) =>
  (DOCUMENT_TYPES.find((t) => t.value === value) || {}).label || value

export const fmtEuro = (v) =>
  v === null || v === undefined || v === ''
    ? '—'
    : `${Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 2 })} €`

export const fmtDate = (v) =>
  v ? new Date(v).toLocaleDateString('fr-FR') : '—'
